module.exports = __webpack_public_path__ + "media/svg/mycorner-eeb58c46.svg";